import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Audience } from '@/domain/types/audience';
import { CollectionBase } from '@/domain/types/collections';
import { listAudiences } from '@/domain/use-cases/audiences/audience-service';
import usePaginatedDocuments from '@/domain/use-cases/get-paginated-documents';
import Button from '@/presentation/components/button';
import LoadMoreButton from '@/presentation/components/load-more-button';
import Table from '@/presentation/components/table';
import { useEffect, useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import { buildReleaseColumns } from './env/columns';

const ReleasesPage = () => {
  const navigate = useNavigate();
  const { data, error, isLoading, isLoadingMore, hasMore, loadMore } =
    usePaginatedDocuments<CollectionBase>(DOCUMENTS_DB.RELEASES);
  const [audiences, setAudiences] = useState<Audience[]>([]);

  useEffect(() => {
    listAudiences()
      .then(setAudiences)
      .catch((e) => console.error('Error cargando audiencias:', e));
  }, []);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data.length && !isLoading) return <div>No hay datos</div>;

  const handleRowClick = (row: CollectionBase) => {
    navigate(`/dashboard/releases/details/${row.id}`);
  };

  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Última Hora</h1>
        <Link to="/dashboard/releases/add">
          <Button label="Agregar Última Hora" icon={<FiPlus />} onClick={() => {}} />
        </Link>
      </div>
      <Table data={data} columns={buildReleaseColumns(audiences)} onRowClick={handleRowClick} />
      <LoadMoreButton hasMore={hasMore} isLoadingMore={isLoadingMore} onLoadMore={loadMore} />
    </div>
  );
};

export default ReleasesPage;
